import * as React from 'react';
// import  request  from '@/server/request';
import config from '@/server/config';
import './index.scss'

import store from '@/redux/index';
import { types } from '@/redux/ui/actionsheet';



interface initProps{
	sucess ?: any,
	text?: string;
	id ?: number,
	disabled ?: any,
	isBtn?: boolean,
	project?: string,
	remove?(): void,
	readOnly?: boolean
	format?: string;
	size?: any;
}


class UploadImg extends React.Component <initProps, any> {
	constructor(props: any) {
		super(props);

		this.state = {
			imgUrl: '',
			isUploading: false,
			imgId: '',
			path: '',
		}
	}

	componentDidMount() {
		let path = '';

		switch(this.props.project) {
			case 'store':
				path = config.IMGAPI;
			break;
			case 'cms':
				path = config.API + 'image/download/picture?imgId=';
			break;
			default:
				path = config.API + 'image/download/crmAnnex?imgId='
			break;
		}

		this.setState({
			path
		});

		if(this.props.id) {
			this.setState({
				imgUrl: path + this.props.id
			})
		}
	}
	componentWillReceiveProps(nextProps:any) {

	    if(nextProps.id) {
	    	this.setState({
				imgUrl: this.state.path + nextProps.id
			})
	    }
	}

	render() {


		return (
			<div className="upload-img" onClick={() => this.photoGraph()}>
				{
					(this.props.isBtn || !this.state.imgUrl) ? <p>{this.props.text || '上传图片'}</p> :
						<div className="upload-relative">
							<img src={this.state.imgUrl} alt="" className="img-view" />
							{
								this.props.remove ? <span onClick={(e: any) => this.removeAction(e)}></span> : null
							}
						</div>
				}
			</div>
			
		)
	}

	private photoGraph() {
		if (this.props.readOnly) {
			return;
		}

		const that = this;

		store.dispatch({
            type: types.ACTIONSHEET_SHOW,
            data: {
            	size: that.props.size
            },
            callback: (r: any) => {
                that.setState({
					imgUrl: this.state.path + (r.source || r.obj),
					imgId: r.source || r.obj,
				},() => {
					that.props.sucess && that.props.sucess(this.state.imgId,  this.state.path + (r.source || r.obj));
				})
            }
        });
	}

	// 删除图片
	private removeAction(e: any) {
		e.stopPropagation();

		if (this.props.readOnly) {
			return;
		}

		if (this.props.remove) { 
			this.props.remove();
		}

	}
}



export default UploadImg